function isCreatableRootPlacement(selectedId, rootPlacementIds) {
    if (selectedId == null) {
        return true;
    }
    return rootPlacementIds.some((placementId)=>placementId == selectedId);
}
function isCreatableRootParentId(parentId, rootPlacementIds, rootId) {
    if (parentId === 0 || parentId === rootId) {
        return true;
    }
    return rootPlacementIds.some((placementId)=>placementId == parentId);
}
function computeCreatableDraftPlacement({ selectedId, rootPlacementIds, draft }) {
    if (isCreatableRootPlacement(selectedId, rootPlacementIds)) {
        return {
            creatableDraft: draft,
            creatableParentId: 0
        };
    }
    return {
        creatableDraft: draft,
        creatableParentId: selectedId
    };
}
function applyCreatableDraftPlacement(options) {
    return computeCreatableDraftPlacement(options);
}
function clearCreatableDraftPlacement() {
    return {
        creatableDraft: undefined,
        creatableParentId: 0
    };
}
function emitCreatableDraftPlacement(options) {
    options.onPlacementChange(computeCreatableDraftPlacement(options));
}
export { applyCreatableDraftPlacement, clearCreatableDraftPlacement, computeCreatableDraftPlacement, emitCreatableDraftPlacement, isCreatableRootParentId, isCreatableRootPlacement };
